import { createSlice } from '@reduxjs/toolkit'

const THEME_CONFIG = {
  ...window.appData,
}

const initialState = {
  showLoader: false,
  isTransactionInProgress: false,
  successText: '',
  routes: [
    {
      key: 'contactDetails',
      to: 'contact-details',
      title: 'Contact Information',
      show: true,
      visited: true,
    },
    {
      key: 'partnerDetails',
      to: 'partner-details',
      title: THEME_CONFIG.taxDetailsTitle || 'GST Information',
      show: true,
      visited: false,
    },
    {
      key: 'bankDetails',
      to: 'bank-details',
      title: 'Bank Information',
      show: THEME_CONFIG['showBankDetails'],
      visited: false,
    },
    {
      key: 'generalDetails',
      to: 'general-details',
      title: 'General Information',
      show: true,
      visited: false,
    },
  ],
  updateRoutes: [
    {
      key: 'contactDetails',
      to: 'contact-details',
      title: 'Contact Information',
      show: true,
      visited: true,
    },
    {
      key: 'bankDetails',
      to: 'bank-details',
      title: 'Bank Information',
      show: true,
      visited: false,
    },
  ],
}

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setLoader: (state, action) => {
      state.showLoader = action.payload
    },
    setTransactionInProgress: (state, action) => {
      state.isTransactionInProgress = action.payload
    },
    setSuccessText: (state, action) => {
      state.successText = action.payload
    },
    addRoutes: (state, action) => {
      const existingKeys = new Set(state.routes.map((route) => route.key))
      const newRoutes = action.payload.filter((route) => !existingKeys.has(route.key))
      if (newRoutes.length) {
        state.routes = [...state.routes, ...newRoutes]
      }
    },
    removeRoutes: (state, action) => {
      state.routes = state.routes.filter((route) => !action.payload.includes(route.key))
    },
    setRoutes: (state, action) => {
      const pathname = action.payload.pathname || ''
      const currentRouteIndex = state.routes.findIndex(
        (route) => pathname === `/registration/${route.to}` || pathname.endsWith(`/${route.to}`)
      )

      if (currentRouteIndex === -1) {
        return
      }

      state.routes = state.routes.map((route, index) => {
        if (index <= currentRouteIndex) {
          route.visited = true
        }
        return route
      })
    },
    setUpdateRoutes: (state, action) => {
      const pathname = action.payload.pathname || ''
      const currentRouteIndex = state.updateRoutes.findIndex(
        (route) => pathname === `/update-details/${route.to}` || pathname.endsWith(`/${route.to}`)
      )

      if (currentRouteIndex === -1) {
        return
      }

      state.updateRoutes = state.updateRoutes.map((route, index) => {
        if (index <= currentRouteIndex) {
          route.visited = true
        }
        return route
      })
    },
  },
})

export const { setLoader, setTransactionInProgress, setSuccessText, setRoutes, setUpdateRoutes, addRoutes, removeRoutes } = commonSlice.actions

export default commonSlice.reducer
